




































































































































































































































import Vue from 'vue';
import { TaskType } from '../../../common/models/TaskType';
import { MassSendMsgType } from '../../models/MassSendMsg';
import CustomerFilterDisplayBox from '../mpgroup/CustomerFilterDisplayBox.vue';
import format from '../../../customer/components/filter/makeCustomerQuery';
import massVuex from '../../vuex/common';
import {BROADCAST} from '../../models/Broadcast';
import moment from 'moment';
import FormatEmoji from '@/common/utils/FormatEmoji';
import massClient from '../../apis';
import SidePage from 'common/components/ui/SidePage/index.vue';
import MassNewsStat from './MassNewsStat.vue';
import { RemarkGroup } from '@/customer/models/RemarkGroup';
import customerClient from '../../../customer/apis';
import massApis from '@/mass/apis'
import _ from 'lodash'

function dripProp(name: string): string {
  return `<drip-prop contenteditable="false">#${name}</drip-prop>`
}

export default Vue.extend({
  mixins: [massVuex],
  components: {
    CustomerFilterDisplayBox,
    SidePage,
    MassNewsStat,
  },
  data() {
    return {
      showDeletePop: false,
      articleIdx: null,
      TaskType,
      MassSendMsgType,
      BROADCAST,
      customerGroups: [],
      moment,
      FormatEmoji,
      visible: false,
      showMassNewsStat: false,
      remarkGroups: [] as RemarkGroup[],
    };
  },
  props: {
    task: {
      type: Object,
    },
    tplData: {
      type: Array as () => any[],
    },
    massFailures: {
      type: Object as () => any,
    },
  },
  mounted() {
    customerClient.getRemarkGroups({}).success((r: any) => {
      this.remarkGroups = r.remarkGroups;
    });
  },
  computed: {
    subNews(): any[] {
      const news = [...this.wxNews]
      news.shift()
      return news
    },
    newsLinks(): string[] {
      return this.task.taskOutAttr && this.task.taskOutAttr.mpNewsLinks || []
    },
    articleIdxes(): number[] {
      return _.range(0, this.task.taskInput.MassSend.msg.WxNews.snapshot.length + 1)
    },
    retryable(): boolean {
      const failures = this.massFailures[this.task.id];
      const startTime = moment(this.task.startAt || this.task.gmtCreate);
      const now = moment();
      const withinTime = startTime.add(12, 'hours').isAfter(now);
      return (failures > 0 || this.task.result === -1) && this.task.status === 2 && withinTime;
    },
    custmerMsg(): any {
      return this.task.taskInput.MassSend && this.task.taskInput.MassSend.msg;
    },
    interactive(): any {
      return this.task.taskInput.MassSend.query.interactive;
    },
    queryFilter(): any {
      return format.query2Filter(this.task.taskInput.MassSend.query, this.remarks, this.remarkGroups);
    },
    msgType(): number {
      if (this.task.taskInput.WxSub) {
        return MassSendMsgType.WxSub;
      } else if (this.custmerMsg.WxText) {
        return MassSendMsgType.Text;
      } else if (this.custmerMsg.WxNews) {
        return MassSendMsgType.News;
      } else if (this.custmerMsg.WxCard) {
        return MassSendMsgType.Card;
      } else if (this.custmerMsg.WxImage) {
        return MassSendMsgType.Image;
      } else if (this.custmerMsg.WxTpl) {
        return MassSendMsgType.Tpl;
      } else {
        return MassSendMsgType.Text;
      }
    },
    wxNews(): any {
      return this.custmerMsg.WxNews.snapshot;
    },
    subTpl(): any {
      const sub =  this.task.taskInput.WxSub
      return sub && sub.tpl
    },
    wxTpl(): any {
      return this.custmerMsg.WxTpl;
    },
    tranProps(): any[] {
      const temp = JSON.parse(JSON.stringify(this.props));
      return temp.map((p: any) => {
        if (p.builtIn) {
          p.fieldName = '\\${' + p.fieldName + '}';
        } else {
          p.fieldName = '\\${privateProps.' + p.fieldName + '}';
        }
        return p;
      });
    },
  },
  methods: {
    onCopy(): void {
      this.$Message.success('复制成功')
    },
    deleteMsg(): void {
      if(this.articleIdx === null) {
        this.$Message.warning('请先选择删除图文编号')
        return
      }
      massApis.deleteMsg({
        taskId: this.task.id,
        articleIdx: this.articleIdx,
      }).success(() => {
        this.showDeletePop = false
        this.$Message.success('删除成功')
      }).failure((msg) => {
        this.showDeletePop = false
        this.$Message.error(`删除失败: ${msg}`)
      })
    },
    retrySend(): void {
      massClient.retrySend({
        id: this.task.id,
      }).success(() => {
        this.$Message.success('成功触发重试');
        this.$emit('retry', this.task.id);
      })
    },
    doMassNewsStat() {
      this.showMassNewsStat = true;
    },
    transValue(value: string) {
      this.tranProps.forEach((p: any) => {
        value = value.replace(new RegExp(p.fieldName, 'g'), dripProp(p.propName));
        value = value.replace(new RegExp('\\${custom.current}', 'g'), dripProp('当前时间'));
      });
      return value;
    },
    getTaskTypeName(type: number) {
      switch (type) {
        case TaskType.MassSend:
          return this.account.weixinType === 1 ? '公众号高级群发' : '公众号群发';
        case TaskType.Broadcast:
          return '广播群发';
        case TaskType.TemplateSend:
          return '模板群发';
        case TaskType.WxSubTpl:
          return '订阅群发'
        default:
          return '未知';
      }
    },
    cancelTask() {
      massClient.cancelTask(this.task.id).success((r: any) => {
        if (r) {
          this.$Message.success('取消成功');
          this.visible = true;
        } else {
          this.$Message.error('取消失败，请刷新页面重试');
        }
      }).error(() => {
        this.$Message.error('取消失败，请刷新页面重试');
      });
    },
    getImageUrl() {
      return this.custmerMsg.WxImage.src;
    },
  },
});
